import loadable from '@loadable/component';
import './styles/index.less';

declare let __webpack_public_path__;
declare let window;

__webpack_public_path__ = `${window.ecologyContentPath || ''}/mobilemode/pc/rc-common/dist/`;

export const PicLibrary = loadable(() => import(/* webpackChunkName: "pic-library" */ './components/pic-library'));

export const SourceCode = loadable(() => import(/* webpackChunkName: "sourcecode" */ './components/sourcecode'));

export const TableLayout = loadable(() => import(/* webpackChunkName: "table-layout" */ './components/table-layout'));

export const FieldLayout = loadable(() => import(/* webpackChunkName: "field-layout" */ './components/field-layout-new'));

export const RichText = loadable(() => import(/* webpackChunkName: "rich-text" */ './components/rich-text'));

export { FOCUS_PLACEHOLDER } from './constants';

